import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { IntuitiveIndication } from '../../models';
import { IndicationTranslatePipe } from '@shared/pipes/indication-translate.pipe';

@Component({
	selector: 'rx-intuitive-indication-button',
	templateUrl: './rx-intuitive-indication-button.component.html',
	styleUrls: ['./rx-intuitive-indication-button.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TlkButtonComponent, IndicationTranslatePipe, NgIf]
})
export class RxIntuitiveIndicationButtonComponent {
	@Input() disabled = false;
	@Input() isActive = false;
	/** Non-interactive presentation (diagram read-only): div with icon + label, no button chrome. */
	@Input() asLabel = false;

	@Input() indication!: IntuitiveIndication;
	@Input() hideIcon?: boolean = false;

	@Output() clicked = new EventEmitter<IntuitiveIndication>();

	onClicked(): void {
		if (!this.disabled) {
			this.clicked.emit(this.indication);
		}
	}

	get indicationClass(): string {
		return (IntuitiveIndication[this.indication] as string | undefined) ?? 'default';
	}
}
